import { UserRole } from "../models/user-role.model";

function getImpliedRoles(role: UserRole): UserRole[] {
  switch (role) {
    case UserRole.SYSADMIN:
      return [UserRole.SYSADMIN, UserRole.MAINTAINER, UserRole.ANALYST];
    case UserRole.MAINTAINER:
      return [UserRole.MAINTAINER, UserRole.ANALYST];
    case UserRole.ANALYST:
      return [UserRole.ANALYST];
    default:
      return [];
  }
}

export function verifyRole(role: UserRole, expectedRole: UserRole): boolean {
  return getImpliedRoles(role).includes(expectedRole);
}